/*Tps-report*/
if (window.location.pathname.includes("reports/qualifying-properties")) {
  const propertyTypes = {
    single: "Single Family Home",
    townhouse: "Townhouse",
    apartment: "Apartment",
    condo: "Condo"
  };

  const amenities = {
    appliances: {
      aircon: "A/C",
      dishwasher: "Dishwasher",
      microwave: "Microwave",
      refrigerator: "Refrigerator",
      stove: "Stove"
    },
    amenities: {
      fenced_yard: "Fenced Yard",
      ranch_style: "Ranch Style",
      handicap_accessible: "Handicap Accessible",
      walk_in_shower: "Walk-in Shower",
      balcony: "Balcony / Deck",
      finished_basement: "Finished Basement",
      lawn_care: "Lawn Care",
      snow_removal: "Snow Removal",
      swimming_pool: "Swimming Pool",
      utilities: "Utilities Included"
    },
    laundry: {
      none: "None",
      in_unit: "In unit",
      shared: "Shared / In-building"
    },
    flooring: {
      carpet: "Carpet",
      hardwood: "Hardwood",
      other: "Other"
    },
    windows: {
      blinds: "Blinds",
      drapes: "Drapes",
      shades: "Shades",
      none: "None"
    }
  };

  $.each($(".data-table"), function() {
    $(this).data("options", window.app_data.datatableOptions);
  });

  $("[name='properties_search']").on("keyup", function() {
    let val = $(this).val();
    $.each($(".data-table"), function() {
      $(this)
        .DataTable()
        .search(val)
        .draw();
    });
  });

  $(".data-table").on("click", ".btn-approve", function(e) {
    const id = $(this).data("id");
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);

    Swal.fire({
      title: "Approve Property",
      html: "Are you sure you want to approve this property?",
      icon: undefined,
      showCancelButton: true,
      confirmButtonText: "Approve",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      preConfirm: async () => await approveProperty(id, table, tr)
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Approved", "Property is approved.", "success");
      }
    });
  });

  $(window).on("tableLoaded", async function(e, table) {
    if (!window.wp_id) return;

    const id = window.wp_id;
    const tr = $(`.btn-view[data-id="${id}"]`)
      .closest("tr")
      .get(0);

    if (!tr) return;

    const data = table
      .DataTable()
      .row(tr)
      .data();

    openDetailsModal(id, data, table, tr);
  });

  $(".data-table").on("click", ".btn-view", function(e) {
    const id = $(this).data("id");
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);
    const data = table
      .DataTable()
      .row(tr)
      .data();

    openDetailsModal(id, data, table, tr);
  });

  function openDetailsModal(id, data, table, tr) {
    if (!data) return;

    Swal.fire({
      title: "Property Details",
      html: getPropertyDetails(data),
      icon: undefined,
      showCancelButton: true,
      confirmButtonText: "Approve",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      width: 1024,
      preConfirm: async () => await approveProperty(id, table, tr)
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Approved", "Property is approved.", "success");
      }
    });
  }

  $(".data-table").on("click", ".btn-delete", function(e) {
    const id = $(this).data("id");
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);

    Swal.fire({
      title: "Delete Property",
      html: "Are you sure you want to delete this property?",
      icon: undefined,
      showCancelButton: true,
      showDenyButton: true,
      showConfirmButton: false,
      denyButtonText: "Delete",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      preDeny: async () => await deleteProperty(id, table, tr)
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "Property is deleted.", "success");
      }
    });
  });

  async function approveProperty(id, table, tr) {
    try {
      const result = await new Promise((resolve, reject) => {
        $.ajax({
          url: `/api/qualifying_property/approve`,
          method: "POST",
          data: { id },
          dataType: "json",
          success: response => resolve(response),
          error: response => reject(response)
        });
      });

      table
        .DataTable()
        .row(tr)
        .remove()
        .draw();
      return result;
    } catch (e) {
      Swal.showValidationMessage(`There is something wrong!`);
      return false;
    }
  }

  async function deleteProperty(id, table, tr) {
    try {
      const result = await new Promise((resolve, reject) => {
        $.ajax({
          url: `/api/qualifying_property/delete/${id}`,
          method: "DELETE",
          dataType: "json",
          success: response => resolve(response),
          error: response => reject(response)
        });
      });

      table
        .DataTable()
        .row(tr)
        .remove()
        .draw();
      return result;
    } catch (e) {
      Swal.showValidationMessage(`There is something wrong!`);
      return false;
    }
  }

  function getPropertyValue(data, propertyPath) {
    const pathParts = propertyPath.split(".");

    let result = data;
    for (let part of pathParts) {
      if (result && result[part] !== undefined) {
        result = result[part];
      } else {
        return [];
      }
    }

    return result || [];
  }

  function getPropertyDetails(data) {
    return `<div class="row text-left">
        <div class="col col-md-6 mb-4">
            <h3>Landlord Information</h3>
            <p class="mb-0"><strong>First Name:</strong> ${data.landlord.first_name || "-"}</p>
            <p class="mb-0"><strong>Last Name:</strong> ${data.landlord.last_name || "-"}</p>
            <p class="mb-0"><strong>Management Company:</strong> ${data.landlord.company || "-"}</p>
            <p class="mb-0"><strong>Phone:</strong> ${data.landlord.phone || "-"}</p>
            <p class="mb-0"><strong>Cell Phone:</strong> ${data.landlord.cellphone || "-"}</p>
            <p class="mb-0"><strong>Email:</strong> ${data.landlord.email || "-"}</p>
            <p class="mb-0"><strong>Billing Address:</strong> ${data.landlord.address || "-"}</p>
        </div>
        <div class="col col-md-6 mb-4">
            <h3>Property Information</h3>
            <p class="mb-0"><strong>Property Type:</strong> ${propertyTypes[data.type] || "-"}</p>
            <p class="mb-0"><strong>Property Address:</strong> ${data.address_1 || "-"}</p>
            <p class="mb-0"><strong>Property City:</strong> ${data.city || "-"}</p>
            <p class="mb-0"><strong>Property State:</strong> ${data.state || "-"}</p>
            <p class="mb-0"><strong>Property Zip:</strong> ${data.zip || "-"}</p>
            <p class="mb-0"><strong>Unit Number:</strong> ${data.unit_number || "-"}</p>
            <p class="mb-0"><strong>Complex:</strong> ${data.complex || "-"}</p>
        </div>

        <div class="col col-md-6 mb-4">
            <h3>Details and Description</h3>
            <p class="mb-0"><strong>Monthly Rent Price:</strong> $${window.formatMoney(data.details.monthly_rent) || "0.00"}</p>
            <p class="mb-0"><strong>Minimum Lease Duration:</strong> ${data.details.lease_duration || "-"}</p>
            <p class="mb-0"><strong>Refundable Security Deposit Amount:</strong> $${window.formatMoney(data.details.security_deposit) || "0.00"}</p>
            <p class="mb-0"><strong>Date Available:</strong> ${
              data.details.date_available ? moment(data.details.date_available).format("MM/DD/YYYY") : "-"
            }</p>
            <p class="mb-0"><strong>Bedrooms:</strong> ${data.details.bedrooms || "0"}</p>
            <p class="mb-0"><strong>Bathrooms:</strong> ${data.details.baths || "0"}</p>
            <p class="mb-0"><strong>Square Footage:</strong> ${data.details.sqft || "0"}</p>
            <p class="mb-0"><strong>Parking:</strong> ${data.details.parking || "0"}</p>
            <p class="mb-0"><strong>Property Website:</strong> <a href="${data.details.website}" target="_blank">${data.details.website || ""}</a></p>
            <p class="mb-0"><strong>School District:</strong> ${data.details.school_district || "-"}</p>
        </div>
        <div class="col col-md-6 mb-4">
            <h3>Amenities and Specifications</h3>
            <p class="mb-0"><strong>Pets Allowed:</strong> ${data.amenities.pets}</p>
            <p class="mb-0"><strong>Furnished:</strong> ${data.amenities.furnished}</p>
            <p class="mb-0"><strong>Appliances:</strong></p>
            <ul class="mb-0">
                ${getPropertyValue(data, "amenities.appliances")
                  .map(amenity => `<li>${amenities.appliances[amenity] || "-"}</li>`)
                  .join("")}
            </ul>
            <p class="mb-0"><strong>Amenities:</strong></p>
            <ul class="mb-0">
                ${getPropertyValue(data, "amenities.amenities")
                  .map(amenity => `<li>${amenities.amenities[amenity] || "-"}</li>`)
                  .join("")}
            </ul>
            <p class="mb-0"><strong>Flooring:</strong> ${(data.amenities && amenities.laundry[data.amenities.laundry]) || "-"}</p>
            <p class="mb-0"><strong>Flooring:</strong></p>
            <ul class="mb-0">
                ${getPropertyValue(data, "amenities.flooring")
                  .map(amenity => `<li>${amenities.flooring[amenity] || "-"}</li>`)
                  .join("")}
            </ul>
            <p class="mb-0"><strong>Windows:</strong></p>
            <ul class="mb-0">
                ${getPropertyValue(data, "amenities.windows")
                  .map(amenity => `<li>${amenities.windows[amenity] || "-"}</li>`)
                  .join("")}
            </ul>
        </div>
    </div>`;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/qualifying-properties.js